import request from './axios_gispai'

// 获取单个图层数据
export function GetLayerInfoById(params) {
  return request({
    url: gispai_baseURL + "api/MapDoc/GetLayerInfoById",
    method: "get",
    params: params,
  });
}

// 获取所有数据（新）
export function GetGData(params) {
  return request({
    url: gispai_baseURL + "api/GData/GetGData",
    method: "get",
    params: params,
  });
}

//获取数据详情
export function getDataDetail_GDB(params) {
  return request({
      url: gispai_baseURL + "api/GData/GetGDataInfoByMap",
      method: 'get',
      params: params
  })
}

// 获取数据库数据（新）
export function getAllTableData (params) {
  return request({
    url: gispai_baseURL + "api/GData/GetAllTableData",
    method: 'get',
    params: params
  })
}

// 获取切片图层数据
export function getGDataObject(params, token) {
  return request({
      url: gispai_baseURL + "api/Edition/GetGDataObject",
      method: 'get',
      params: params,
      cancelToken: token
  })
}

// 地图派登录
// export function Login(params) {
//   return request({
//     url: "https://lyapp.gispai.com/api/User/login",
//     method: "post",
//     data: params,
//   });
// }

export function Login(params) {
  return request({
    url: "https://pro.gispai.com/api/User/login",
    method: "post",
    data: params,
  });
}